import { useEffect } from 'react'
import { useHistory } from 'react-router-dom'

const PcPageHolder = ({ redirectUrl = '/' } = {}) => {
  const history = useHistory()
  useEffect(() => {
    history.replace(redirectUrl)
  }, [])

  return null
}

export default PcPageHolder
